/** Milliseconds since 1970 */
export type TimeStamp = number;

export enum Team {
	/** 'Blue Team' is user facing name */
	A = 0,
	/** 'Red Team' is user facing name  */
	B = 1,
}

export type GamePhase = 'setup' | 'faceoff' | 'playOrPass' | 'answering' | 'steal' | 'reveal' | 'roundEnd' | 'gameEnd';

export type AnswerConfig = {
	text: string;
	points: number;
};

export type GameplayAnswer = AnswerConfig & {
	revealed: boolean;
};

export type QuestionId = `q${number}`;
export type QuestionSetId = `qset${number}`;

/** A single question */
export type QuestionConfig = {
	id: QuestionId;
	text: string;
	answers: AnswerConfig[];
	tags: string[];
	isActive: boolean;
	createdAt: TimeStamp;
	updatedAt: TimeStamp;
	authorName: string;
};

/** Question set with question ids. As stored in the database. */
export type QuestionSetConfig = {
	id: QuestionSetId;
	name: string;
	description: string;
	authorName: string;
	isActive: boolean;
	questionIds: QuestionId[];
	tags: string[];
	createdAt: TimeStamp;
	updatedAt: TimeStamp;
};

/** Question set with questions, not just IDs, for use in gameplay. */
export type QuestionSet = Omit<QuestionSetConfig, 'questionIds'> & {
	questions: QuestionConfig[];
};

export const PHASE_DISPLAY_NAMES: Record<GamePhase, string> = {
	setup: 'Setup',
	faceoff: 'Face Off!',
	playOrPass: 'Play or Pass?',
	answering: 'Play the Board',
	steal: 'Steal Opportunity!',
	reveal: 'Remaining answers',
	roundEnd: 'Round Complete!',
	gameEnd: 'Game Over',
};
